module.exports = __webpack_public_path__ + "img/address.4b6ffb06.png";